/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard'
    },
    {
        id: 'modules',
        title: 'Modules',
        type: 'basic',
        icon: 'heroicons_outline:view-grid',
        link: '/admin/modules'
    },
    {
        id: 'currency',
        title: 'Currency',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/admin/currency'
    },
    {
        id: 'apps',
        title: 'Applications',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/admin/apps'
    },
    {
        id: 'organizations',
        title: 'Organizations',
        type: 'basic',
        icon: 'heroicons_outline:office-building',
        link: '/admin/organizations'
    },
    {
        id: 'branches',
        title: 'Branches',
        type: 'basic',
        icon: 'heroicons_outline:collection',
        link: '/admin/branches'
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/admin/users'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard'
    },
    {
        id: 'profile',
        title: 'Profile',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/admin/profile'
    },
    {
        id: 'modules',
        title: 'Modules',
        type: 'basic',
        icon: 'heroicons_outline:view-grid',
        link: '/admin/modules'
    },
    {
        id: 'currency',
        title: 'Currency',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/admin/currency'
    },
    {
        id: 'apps',
        title: 'Applications',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/admin/apps'
    },
    {
        id: 'organizations',
        title: 'Organizations',
        type: 'basic',
        icon: 'heroicons_outline:office-building',
        link: '/admin/organizations'
    },
    {
        id: 'branches',
        title: 'Branches',
        type: 'basic',
        icon: 'heroicons_outline:collection',
        link: '/admin/branches'
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/admin/users'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard'
    },
    {
        id: 'profile',
        title: 'Profile',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/admin/profile'
    },
    {
        id: 'modules',
        title: 'Modules',
        type: 'basic',
        icon: 'heroicons_outline:view-grid',
        link: '/admin/modules'
    },
    {
        id: 'currency',
        title: 'Currency',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/admin/currency'
    },
    {
        id: 'apps',
        title: 'Applications',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/admin/apps'
    },
    {
        id: 'organizations',
        title: 'Organizations',
        type: 'basic',
        icon: 'heroicons_outline:office-building',
        link: '/admin/organizations'
    },
    {
        id: 'branches',
        title: 'Branches',
        type: 'basic',
        icon: 'heroicons_outline:collection',
        link: '/admin/branches'
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/admin/users'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard'
    },
    {
        id: 'profile',
        title: 'Profile',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/admin/profile'
    },
    {
        id: 'modules',
        title: 'Modules',
        type: 'basic',
        icon: 'heroicons_outline:view-grid',
        link: '/admin/modules'
    },
    {
        id: 'currency',
        title: 'Currency',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/admin/currency'
    },
    {
        id: 'apps',
        title: 'Applications',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/admin/apps'
    },
    {
        id: 'organizations',
        title: 'Organizations',
        type: 'basic',
        icon: 'heroicons_outline:office-building',
        link: '/admin/organizations'
    },
    {
        id: 'branches',
        title: 'Branches',
        type: 'basic',
        icon: 'heroicons_outline:collection',
        link: '/admin/branches'
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/admin/users'
    }
];
